import { render } from "./consentform.vue?vue&type=template&id=2b3c6138&scoped=true"
import script from "./consentform.js?vue&type=script&lang=js"
export * from "./consentform.js?vue&type=script&lang=js"

import "./consentform.vue?vue&type=style&index=0&id=2b3c6138&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3c6138"]])

export default __exports__